import { Suspense, lazy } from "react";
import UXloader from "../components/layouts/UXloader";

const Loadable = (Component) => (props) => {
  return (
    <Suspense fallback={<UXloader />}>
      <Component {...props} />
    </Suspense>
  );
};

// COMPONENTS
export const Products = Loadable(lazy(() => import("../components/products")));
export const Dashboard = Loadable(lazy(() => import("../components/dashboard")));
export const TestReport = Loadable(lazy(() => import("../components/test-report")));
export const TestCreation = Loadable(lazy(() => import("../components/test-creation")));
export const NewTest = Loadable(lazy(() => import("../components/test-creation/NewTest")));
export const TestPreview = Loadable(lazy(() => import("../components/test-preview")));
export const Template = Loadable(lazy(() => import("../components/templates/Template")));
export const AnalysisSpace = Loadable(lazy(() => import("../components/projectanalysis")));
export const Response = Loadable(lazy(() => import("../components/testerview/Index")));
export const EndScreen = Loadable(lazy(() => import("../components/testerview/EndScreen")));
export const StartScreen = Loadable(lazy(() => import("../components/testerview/StartScreen")));
export const BrowserTest = Loadable(lazy(() => import("../components/browser-test")));
export const EmbedViewer = Loadable(lazy(() => import("../components/embed-viewer/EmbedViewer")));
export const DashboardModerated = Loadable(lazy(() => import("../components/dashboard-moderated")));
export const ModeratedReport = Loadable(lazy(() => import("../components/dashboard-moderated/Report")));
export const Heatmap = Loadable(lazy(() => import("../components/test-report/Heatmap")));
export const DashboardCommon = Loadable(lazy(() => import("../components/dashboard-common")));
export const Plans = Loadable(lazy(() => import("../components/subscriptions/Plans")));
export const UpgradePlan = Loadable(lazy(() => import("../components/subscriptions/UpgradePlan")));
export const TopUp = Loadable(lazy(() => import("../components/subscriptions/TopUp")));
export const NavigationTree = Loadable(lazy(() => import("../components/test-report/NavigationTree")));

// ERROR
export const Error404 = Loadable(lazy(() => import("../components/layouts/Error404")));

// User
export const EditProfile = Loadable(lazy(() => import("../components/user/EditProfile")));
export const Billings = Loadable(lazy(() => import("../components/user/Billings")));
export const Subscriptions = Loadable(lazy(() => import("../components/user/Subscriptions")));
export const Integrations = Loadable(lazy(() => import("../components/user/Integrations")));
export const GlobalSettings = Loadable(lazy(() => import("../components/user/GlobalSettings")));
export const UserOnboarding = Loadable(lazy(() => import("../components/user/UserOnboarding")));
export const People = Loadable(lazy(() => import("../components/organization/People")));
export const Organization = Loadable(lazy(() => import("../components/organization/Organization")));
export const Workspace = Loadable(lazy(() => import("../components/organization/Workspace")));
export const WorkspaceSwitch = Loadable(lazy(() => import("../components/organization/WorkspaceSwitch")));
export const WorkspaceInvitation = Loadable(lazy(() => import("../components/organization/WorkspaceInvitation")));

// Toolkit
export const ToolkitDashboard = Loadable(lazy(() => import("../components/toolkit/components/dashboard")));
export const ToolkitTestCreation = Loadable(lazy(() => import("../components/toolkit/components/test-creation")));
export const ToolkitTestCreationInit = Loadable(lazy(() => import("../components/toolkit/components/test-creation/TestInit")));
export const ToolkitTestReport = Loadable(lazy(() => import("../components/toolkit/components/test-report/")));
export const ToolkitTestReportPieTree = Loadable(lazy(() => import("../components/toolkit/components/test-report/PieTreeIndex")));
export const ToolkitTestStudy = Loadable(lazy(() => import("../components/toolkit/components/test-study")));
export const ToolkitCardSortBegin = Loadable(lazy(() => import("../components/toolkit/components/test-study/CardSortBegin")));
export const ToolkitTreeStudyBegin = Loadable(lazy(() => import("../components/toolkit/components/test-study/TreeStudyBegin")));
// export const ToolkitParticipateStudyBegin = Loadable(
//   lazy(() => import("../components/toolkit/components/test-study/ParticipateStudyBegin"))
// );
export const ToolkitStudyInterrupted = Loadable(lazy(() => import("../components/toolkit/components/test-study/StudyInterrupted")));
export const ToolkitQuestionnaireBegin = Loadable(
  lazy(() => import("../components/toolkit/components/test-study/QuestionnaireBegin"))
);
export const ToolkitQuestionnaireThankYou = Loadable(
  lazy(() => import("../components/toolkit/components/test-study/layouts/QuestionnaireThankYou"))
);
